import React from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ArrowBackIosIcon from '@material-ui/icons/ArrowForwardIos'
import clsx from 'clsx'

import { specialTheme, widthXS } from '../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: specialTheme.colors.violet.light,
    maxWidth: '100%',
    minHeight: 116,
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    maxWidth: 1180,
  },
  text: {
    color: specialTheme.colors.darkRed,
    fontFamily: specialTheme.font.fontFSMe,
    fontSize: '1.875rem',
    fontWeight: 400,
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '1.125rem',
    },
  },
  sub: {
    color: specialTheme.colors.darkRed,
    fontFamily: specialTheme.font.fontFSMe,
    fontSize: '0.8125rem',
    fontWeight: 400,
    padding: '0.5rem 0',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.6875rem',
    },
  },
  roundButton: {
    textAlign: 'center',
    color: specialTheme.colors.darkRed,
    fontFamily: specialTheme.font.fontFSMe,
    height: '2rem',
    width: '2rem',
    lineHeight: '2rem',
    border: `2px solid ${specialTheme.colors.darkRed}`,
    borderRadius: '50%',
    [theme.breakpoints.down(widthXS)]: {
      height: '1.8rem',
      width: '1.8rem',
    },
  },
  pointer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  active: {
    backgroundColor: specialTheme.colors.darkRed,
    color: specialTheme.colors.white,
  },
  buttonIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    color: specialTheme.colors.darkRed,
    padding: '0 0.5rem',
    height: '1rem',
    width: '1rem',
    backgroundSize: '100% 100%',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export interface NavBarProps {
  title: string // localized title of the navbar
  subTitle: string // localized subtitle of the navbar
  items?: NavBarItem[] // items of the navbar
}

export interface NavBarItem {
  title: string
  isCurrent: boolean
  isClickable: boolean
  onClick: () => void
}

/*
 * Extracted NavBar component that can be configured from the outside
 */
function NavBar(props: NavBarProps) {
  //const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Container className={classes.root}>
      <Grid container direction="row" className={classes.container}>
        <Grid item xs={12} sm={6} xl={6}>
          <Typography className={classes.text} variant="h1">
            {props.title}
          </Typography>
          <div className={classes.sub}>{props.subTitle}</div>
        </Grid>
        <Grid item xs={12} sm={6} xl={6} className={classes.center}>
          {props.items != null &&
            props.items.map((item: NavBarItem, index) => {
              return (
                <React.Fragment key={index}>
                  <div
                    className={clsx(
                      { [classes.roundButton]: true },
                      { [classes.active]: item.isCurrent },
                      { [classes.pointer]: item.isClickable }
                    )}
                    key={index}
                    onClick={() => {
                      if (item.isClickable) {
                        item.onClick()
                      }
                    }}
                  >
                    {item.title}
                  </div>
                  {index + 1 < props.items!.length ? (
                    <ArrowBackIosIcon className={classes.buttonIcon} />
                  ) : null}
                </React.Fragment>
              )
            })}
        </Grid>
      </Grid>
    </Container>
  )
}

export default NavBar
